export default function XIcon() {
  return <>✕</>;
}
